import { findImageContentBox } from '../common/pokCore/validation/imageContentBox';

const loadImage = (src: string) =>
  new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });

/**
 * Cuts the empty margins around the drawing in a PNG (as a data URL), the same
 * way pok-core does (shared findImageContentBox).
 * Returns the original image when there is nothing to cut or it cannot be read.
 */
export const trimImageMargins = async (dataUrl: string): Promise<string> => {
  try {
    const image = await loadImage(dataUrl);
    const source = document.createElement('canvas');
    source.width = image.width;
    source.height = image.height;
    const sourceContext = source.getContext('2d');
    if (!sourceContext) {
      return dataUrl;
    }
    sourceContext.drawImage(image, 0, 0);
    const { data } = sourceContext.getImageData(
      0,
      0,
      image.width,
      image.height,
    );

    const box = findImageContentBox(data, image.width, image.height);
    if (!box) {
      return dataUrl;
    }

    const target = document.createElement('canvas');
    target.width = box.width;
    target.height = box.height;
    target
      .getContext('2d')
      ?.drawImage(
        source,
        box.left,
        box.top,
        box.width,
        box.height,
        0,
        0,
        box.width,
        box.height,
      );
    return target.toDataURL('image/png');
  } catch {
    return dataUrl;
  }
};
